import React,{ FC,useState,useEffect, useRef } from 'react';
import {BsChevronDown, BsChevronUp} from 'react-icons/bs';
import { TbSearch } from 'react-icons/tb';
import { errorStyle, flexer } from '../../styles/globalStyles';
import IconInput from '../IconInput';

export interface Option {
  value: string,
  label?: string // incase its not provided, we render the actual value
}

interface Props {
  onChange: (value:string) => void,
  showSearch?: boolean,
  placeholder?: string,
  className?: string,
  data: Option[],
  value?: string,
  error?: string,
  label?: string,
  disabled?: boolean
}

const SelectField:FC<Props> = ({ error,value,label,onChange,data,placeholder,className, disabled=false,showSearch = false }) => {
  const [ customData,setCustomData ] = useState<Option[]>([])
  const [ showModal,setModal ] = useState<boolean>(false)
  const selectRef = useRef<HTMLDivElement | null>(null)
  const [ localValue,setValue ] = useState<string>()
  const [ query,setQuery ] = useState<string>()
  //
  useEffect(()=>{
    if(value){
      /**
       * when the valued is updated,
       * it find the corresponding value
       * in the data, and sets it label
       */
      for(const one of data){
        if(one.value.includes(value) || one.label?.includes(value)){
          setValue(one.label || one.value)
        }
      }
    }else{
      setValue('')
    }
  },[value,data])

  useEffect(()=>{
    // clicke event that's incharge of 
    // closing the modal
    document.addEventListener('click', (e:any) => {
      if(e.target && e.target.contains(selectRef.current)){
        setModal(false)
      }
    })

    return () => {
      // clear the event
      document.removeEventListener('click', () => {
        setModal(false)
      })
    }
  },[])

  useEffect(()=>{
    if(query){
      const newData = data.filter(({ value }) => String(value).toLowerCase().includes(query.toLowerCase()) )
      setCustomData(newData)
    }else{
      setCustomData(data)
    }
  },[query,data])

  const toggleModal = () => {
    if(!disabled)
    setModal( prev => !prev)
  }

  const handleChange = (value:string,label?:string) => {
    onChange(value)
    setValue(label||value)
    toggleModal()
  }

  return (
    <div className={`w-full flex my-3 relative flex-col ${className}`} ref={selectRef}>
      { label ? <label className="font-medium text-gray-400">{label}</label> : null}
      <div className={flexer+`p-3 cursor-pointer mt-1 border rounded-md ${disabled && 'bg-gray-50'}`} onClick={toggleModal}>
        {
          localValue ?
            <p className="font-medium text-gray-700">{localValue}</p> :
            <p className="text-gray-400" >{placeholder || "Choose"}</p>  
        }
        {
          showModal ?
            <BsChevronUp className="text-gray-600" />:
            <BsChevronDown className="text-gray-600" />
        }
      </div>
      {
        showModal &&
        <div className="absolute w-full top-full left-0 z-20 rounded-md shadow-lg p-3 bg-white" >
          {
            showSearch &&
            <IconInput
              value={query}
              Icon={TbSearch}
              style={{padding:0}}
              placeholder="Search"
              onChange={val => setQuery(val)}
            />
          }
          <div className="max-h-40 overflow-y-scroll">
            { // creating unique keys
              React.Children.toArray(
                customData.map(({ value,label },index) => 
                  <p 
                    className={`px-5 py-1 rounded-md w-full cursor-pointer hover:bg-blue-100 hover:text-PRIMARY ${index ? null : 'mt-1'} `}
                    onClick={() => handleChange(value,label)} 
                  >
                    {label || value}
                  </p>  
                )
              )
            }
          </div>
        </div>
      }
      <p className={errorStyle}>{ !localValue ? error : null}</p>
    </div>
  )
}

export default SelectField
